import React, { useEffect, useState } from 'react';
import Sidebar from "./Sidebar";
import DashboardHeader from "./DashboardHeader";
import APIs from '../../APIs';
import ChatWidget from '../../components/ChatWidget';

const ChatList = () => {
    const [loading, setLoading] = useState(true);
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    const [chatList, setChatList] = useState([])
    const [activeChat, setActiveChat] = useState(null);
    const [selectedChatItem, setSelectedChatItem] = useState('')

    useEffect(() => {
        fetchChatList()
    }, [])

    const fetchChatList = async () => {
        setLoading(true);
        try {
            const res = await APIs.post("user/getChannelsByUser", {
                user_id: userData.user_id,
            });

            const data = res?.data?.data;
            console.log("res", data)
            if (data) {
                setLoading(false);
                setChatList(res.data.data)
            } else {
                setLoading(false);

            }
        } catch (err) {
            console.error("Error fetching fetchChatList", err);
            setLoading(false);

        } finally {
            setLoading(false);
        }
    };

    const handleChatClick = (item) => {
        setSelectedChatItem(item);
        setActiveChat(item.sp_id); // or whatever ID you use
    };

    console.log("activeChat", activeChat)
    return (
        <>
            {/* Page Content */}
            <div className="page-content">
                {/* About-us start */}
                <section className="step-section-md">
                    <div className="container">
                        <div className="row">
                            {/* Sidebar */}
                            <div className="col-lg-3">
                                <Sidebar></Sidebar>
                            </div>

                            {/* Main Content */}
                            <div className="col-lg-9">
                                {/* <DashboardHeader></DashboardHeader> */}

                                <div className="card mt-30">
                                    <div className="card-header bg-white">
                                        <h5 className="card-title">Chat List</h5>
                                    </div>

                                    <div className="card-body">
                                        {/* Sample Notification - you can map over real data here */}
                                        {chatList?.length !== 0 ?
                                            <div>
                                                {chatList.map((item, index) => (
                                                    <div className="notification-wraper" key={index} onClick={() => handleChatClick(item)}>
                                                        <div className="notification-containt">
                                                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                <div
                                                                    style={{
                                                                        width: "40px",
                                                                        height: "40px",
                                                                        borderRadius: "50%",
                                                                        backgroundColor: "#ccc", // gray background
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        fontSize: "18px",
                                                                        color: "#fff",
                                                                    }}
                                                                >
                                                                    <i className="ti-user"></i>
                                                                </div>
                                                                <h5>{item.sp_name}</h5>
                                                            </div>
                                                            <div className="notification-date">
                                                                <i className="ti-arrow-right" style={{ marginRight: 5, alignSelf: 'center' }}></i>
                                                            </div>
                                                        </div>

                                                    </div>
                                                ))}
                                            </div>
                                            :
                                            <div className="col-12 text-center my-5">
                                            <img
                                              src="/images/nodatafoundimg.png"
                                              alt="No addresses found"
                                              className="img-fluid mb-3"
                                              style={{ maxWidth: "200px" }}
                                            />
                                            <p>No chat found.</p>
                                          </div>
                                        }
                                        {activeChat && (
                                            <ChatWidget
                                                bookingId={activeChat}
                                                user={userData}
                                                sp={selectedChatItem}
                                                fromChatlist={true}
                                                onClose={() => setActiveChat(null)}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                            {/* End Main Content */}
                        </div>
                    </div>
                </section>
                {/* About-us End */}
            </div>
            {/* Page Content End */}
        </>
    );
};

export default ChatList;
